export const columnConfig = [
  {
    label: '线索 ID',
    name: 'leadId',
  },
  {
    label: '导入时间',
    name: 'leadCreateTime',
  },
  {
    label: '线索来源',
    name: 'systemSourceType',
  },
  {
    label: '公司名称',
    name: 'company.companyName',
  },
  {
    label: '阶段',
    name: 'progressStatus',
  },
  {
    label: '状态',
    name: 'cleaningStatus',
  },
  {
    label: '线索跟进人',
    name: 'ownerId',
  },
  {
    label: '商机跟进人',
    name: 'potential',
  },
  {
    label: '运营人员',
    name: 'followOperatorList',
  },
  {
    label: '服务商',
    name: 'agencyName',
  },
  {
    label: '分发时间',
    name: 'distributeTime',
  },
];
